const strings = {
  title: 'Nova Interação Referência',
}

export default strings
